<template>
<div class="chapter">
<div class="inner_page">
<p class="centeraaf"><a id="ded"></a><a id="page_vii"><span class="txit">Don’t be afraid of darkness,<br/>for in darkness rests the light.<br/>We see no stars or planets<br/>without the dark of night.<br/>The darkness of the pupil<br/>is in the iris round,<br/>for all light’s fearful longing<br/>has darkness at its ground.<br/>Don’t be afraid of darkness,<br/>for in it rests the light.<br/>Don’t be afraid of darkness;<br/>it holds the heart of light</span>.</a></p><a id="page_vii">
</a><p class="center"><a id="page_vii">—Erik Blomberg</a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?171382c8